export class InlineCompletionsAccessibleView {
}
//# sourceMappingURL=inlineCompletionsAccessibleView.js.map